export const chooseLocalFile = <T extends true | false>(
    accept: string = "*/*",
    multiple: T = false as T,
    timeout: number = 300_000,
): T extends false ? Promise<File | null> : Promise<File[] | null> => {
    return new Promise((resolve) => {
        const ip = document.createElement("input");
        ip.type = "file";
        ip.accept = accept;
        if (multiple) {
            ip.multiple = true;
        }
        const timerId = setTimeout(() => {
            ip.onchange = null;
            resolve(null);
        }, timeout);
        ip.onchange = (_) => {
            clearTimeout(timerId);
            ip.onchange = null;
            const files = ip.files;
            if ((files === null) || (files.length <= 0)) {
                resolve(null);
                return;
            }
            if (multiple) {
                // sort files by name
                const fList: File[] = [];
                for (const f of files) {
                    fList.push(f);
                }
                fList.sort((f1, f2) =>
                    f1.name.localeCompare(
                        f2.name,
                        undefined,
                        {
                            sensitivity: "base",
                            numeric: true,
                            caseFirst: "false",
                        },
                    )
                );
                resolve(fList);
            } else {
                resolve(files[0]);
            }
        };
        ip.click();
    }) as (T extends false ? Promise<File | null> : Promise<File[] | null>);
};

export const downloadFile = (data: BlobPart[], name: string) => {
    const blob = new Blob(data, {
        type: "application/octet-stream",
    });
    const a = document.createElement("a");
    a.download = name;
    a.href = URL.createObjectURL(blob);
    a.click();
};

export const getFileContent = async (file: File) => {
    return new Uint8Array(await file.arrayBuffer());
};
